import Vue from 'vue'
import { isNemoApp } from './index'
import { isMobileDevice } from './device'

function setRem () {
  const html = document.documentElement
  const isNemoAppFlag = isNemoApp()
  const isMobileDeviceFlag = isMobileDevice()
  Vue.prototype.isNemoApp = isNemoAppFlag
  Vue.prototype.isMobileDevice = isMobileDeviceFlag
  if (isMobileDeviceFlag) {
    const baseSize = 32
    const designWith = 750
    const scale = html.clientWidth / designWith
    html.style.fontSize = Math.max(baseSize / 2, Math.min(baseSize * scale, baseSize)) + 'px'
  } else {
    html.style.fontSize = ''
  }
}

setRem()
window.addEventListener('resize', setRem)
